import './App.css';
import Test from "./test";
import Lobby from './Lobby';
import { useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { motion } from "framer-motion";
import GestorTurnos from './GestorTurnos';
import GuiaUso from './components/GuiaUso';


export default function RutasAnimadas() {

    const location = useLocation();
    console.log(location);
    console.log(process.env.PUBLIC_URL);

    return(
        <Routes location={location} key={location.pathname}>
            <Route exact path='/' element={
                <motion.div
                    initial={{ y: 10, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -10, opacity: 0 }}
                    transition={{ duration: 0.8 }} 
                    className='lobby'>
                    <Lobby/>
                </motion.div>}>
            </Route>
            <Route path='/formTurno' element={
                <motion.div
                    initial={{ y: 10, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -10, opacity: 0 }}
                    transition={{ duration: 0.8 }} 
                    className='turnera'>
                    <Test/>
                </motion.div>}>
            </Route>
            <Route path='/uso' element={
                <motion.div
                    initial={{ y: 10, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -10, opacity: 0 }}
                    transition={{ duration: 0.8 }} 
                    className='guia'>
                    <GuiaUso/>
                </motion.div>}>
            </Route>
            <Route path='/gestiones' element={<GestorTurnos/>} ></Route>
        </Routes>
    )
}